import { EarningsInsight } from '@toggle/toggle';
import React from 'react';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import {
  SubTabsType,
  useEarningsInsightDrawer,
} from '~/widgets/earnings-insight-drawer/useEarningsInsightDrawer';

import { EarningsInsightTooltip } from '../earnings-insight-tooltip/EarningsInsightTooltip';
import * as S from './EarningsInsightIcon.styles';
import { getEarningsInsightIconName } from './utils';

export interface EarningsInsightIconProps {
  size?: number;
  width?: number;
  height?: number;
  entityTag: string;
  earningsInsight: EarningsInsight;
  isDisabled?: boolean;
  enableHover?: boolean;
  isBordered?: boolean;
  source: PosthogTrackingSource;
  customSize?: { width: number; height: number };
}

export const EarningsInsightIcon = ({
  entityTag,
  earningsInsight,
  isDisabled = false,
  enableHover = true,
  isBordered = true,
  customSize,
  size,
  source,
  ...rest
}: EarningsInsightIconProps) => {
  const { openDrawer } = useEarningsInsightDrawer();

  const isPreview = earningsInsight.type === 'preview';
  const iconProps = {
    iconName: getEarningsInsightIconName(isPreview, isBordered),
    viewBox: isBordered ? '0 0 30 32' : '0 0 12 12',
  };

  return (
    <TooltipContainer
      label={
        <EarningsInsightTooltip
          earningsInsight={earningsInsight}
          isPreview={isPreview}
          iconProps={iconProps}
        />
      }
      placement="top-start"
      offsetY={-5}
      offsetX={8}
      hasMaxWidth={false}
      disabled={!enableHover || isDisabled}
      inPortal
    >
      <S.StyledIcon
        {...iconProps}
        {...rest}
        {...(customSize
          ? { width: customSize.width, height: customSize.height }
          : { size })}
        $isDisabled={isDisabled}
        $enableHover={enableHover}
        onClick={e => {
          e.stopPropagation();
          openDrawer({
            entityTag,
            earningsId: earningsInsight.earnings_id,
            subtab: isPreview ? SubTabsType.Preview : SubTabsType.Recap,
            source,
          });
        }}
      />
    </TooltipContainer>
  );
};
